export class SetAccountStateError extends Error {
    public readonly name: string;
    public readonly stack: string;

    constructor(message: string, stack: string = '') {
        super(message);
        this.name = 'SetAccountStateError';
        this.stack = stack;
        Object.setPrototypeOf(this, SetAccountStateError.prototype);
    }
}
